import React, {Fragment, ReactNode} from 'react';
import classNamesBind from "classnames/bind";
import styles from './InputNationSales.module.scss';
import {AddCircleOutline, Close} from "@material-ui/icons";
import {Tooltip} from "@material-ui/core";
import {useSelector} from "react-redux";
import {CopyUtil} from "../../../../../utils/copyUtil/copyUtil";
import NumberFormat from "react-number-format";
import {useTranslation} from "react-i18next";
import {DataState} from "../../../../../redux/Data";
import {OnChangeValue} from "../../../../Intefaces";
import {NationSales} from "../../../../../graphql/customScalars";

const cx = classNamesBind.bind(styles);

export const InputNationSales = (props: {
    title: ReactNode,
    value: NationSales,
    onChangeValue: OnChangeValue<NationSales>
}) => {
    const data = useSelector<any, DataState>(state => state.data);
    const [t] = useTranslation('common');

    return (
        <Fragment>
            <div className={cx('title')}>{props.title}</div>
            <p className={cx('info')}>{t('mypageJoin.nationSalesDesc')}</p>

            <div className={cx('table')}>
                <div className={cx('header', 'col-delete')}/>
                <div className={cx('header', 'col-nation')}>{t('mypageJoin.nation')}</div>
                <div className={cx('header', 'col-sales')}>{t('mypageJoin.sales')}</div>
            </div>

            {props.value.map((value, index) => {
                return (
                    <div key={index} className={cx('table', 'hover')}>
                        <div className={cx('header', 'col-delete')}>
                            <Tooltip title={t('mypageJoin.btnDelete') || ''} onClick={event => {
                                let copy = CopyUtil.copy(props.value);
                                copy = [...copy.slice(0, index), ...copy.slice(index + 1, copy.length)]
                                props.onChangeValue(copy);
                            }}>
                                <Close className={cx('btn-add')} style={{marginTop: -8}}/>
                            </Tooltip>
                        </div>
                        <div className={cx('col-input', 'col-nation')}>
                            <select
                                className={cx('form-control', 'form-control-sm')}
                                value={value.nationCode}
                                onChange={event => {
                                    const copy = CopyUtil.copy(props.value);
                                    copy[index].nationCode = event.target.value;
                                    props.onChangeValue(copy);
                                }}>
                                {data.nationCode.map((nationCode, idx) => {
                                    return <option
                                        key={idx}
                                        value={nationCode.code}>({nationCode.code.toUpperCase()}) {nationCode.shortNm}</option>
                                })}
                            </select>
                        </div>

                        <div className={cx('col-input', 'col-sales')}>
                            <NumberFormat
                                thousandSeparator
                                className={cx('form-control', 'form-control-sm', 'text-right')}
                                value={value.sales}
                                displayType='input'
                                decimalScale={0}
                                onValueChange={values => {
                                    const copy = CopyUtil.copy(props.value);
                                    copy[index].sales = values.floatValue || 0;
                                    props.onChangeValue(copy);
                                }}/>
                        </div>
                    </div>
                )
            })}


            <div className={cx('table')}>
                <div className={cx('col', 'col-delete')}/>
                <div className={cx('col', 'col-add', 'text-center')}>
                    <Tooltip title={t('mypageJoin.btnAdd') || ''} onClick={event => {
                        const copy = CopyUtil.copy(props.value);
                        copy.push({nationCode: "KR", sales: 0});
                        props.onChangeValue(copy);
                    }}>
                        <AddCircleOutline className={cx('btn-add')}/>
                    </Tooltip>
                </div>
            </div>

            <div style={{height: 15}}/>

        </Fragment>
    )
}

